import { $, $$ } from './_queryselector.js';

function easeInCubic (t) { return t*t*t }

function hover() {
    return {
        inSpeed: 300,
        outSpeed: 400,

        circle: null,
        path: null,
        totalLength: 565.486677646,
        isBig: false,

        inHandle: null,
        inStart: null,
        inProgress: 0,

        outHandle: null,
        outStart: null,
        outProgress: 0,

        init: function(el) {
            this.circle = $('.js-ring', el);
            this.path = $('circle', el);
            el.addEventListener('mouseenter', () => {
                if (this.outHandle) {
                    cancelAnimationFrame(this.outHandle);
                }
                this.inHandle = requestAnimationFrame(() => this.drawIn());
            });
            el.addEventListener('mouseleave', () => {
                if (this.inHandle) {
                    cancelAnimationFrame(this.inHandle);
                }
                this.outHandle = requestAnimationFrame(() => this.drawOut());
            });
        },

        drawIn: function() {
            if (!this.inStart) {
                this.inStart = performance.now();
            }
            this.inProgress = (performance.now() - this.inStart) / this.inSpeed;
            
            let offset = 0;
            if (this.inProgress <= 1) {
                offset = easeInCubic((1-this.inProgress)) * this.totalLength;
            }
            this.path.style.strokeDashoffset = offset;
            if (this.inProgress > 0.8 && !this.isBig) {
                this.isBig = true;
                this.circle.classList.add('social-icon__ring--big');
            }
            if (this.inProgress > 1) {
                this.inStart = null;
                this.inProgress = 1;
                window.cancelAnimationFrame(this.inHandle);
                return;
            }
            
            this.inHandle = requestAnimationFrame(() => this.drawIn());
        },
        
        drawOut: function() {
            if (this.isBig) {
                this.isBig = false;
                this.circle.classList.remove('social-icon__ring--big');
            }
            
            this.inStart = null;
            if (!this.outStart) {
                this.outStart = performance.now();
            }
            this.outProgress = (1 - this.inProgress) + ((performance.now() - this.outStart) / this.outSpeed);

            let offset = this.totalLength;
            if (this.outProgress <= 1) {
                offset = easeInCubic(this.outProgress) * this.totalLength;   
            }
            this.path.style.strokeDashoffset = offset;
            
            if (this.outProgress > 1) {
                cancelAnimationFrame(this.outHandle);
                this.outStart = null;
                return;
            }
            
            this.outHandle = requestAnimationFrame(() => this.drawOut());
        },
    };
}

const icons = $$('.js-social-icon');

for (let i = 0; i < icons.length; i++) {
    hover().init(icons[i]);
}



// WEBPACK FOOTER //
// ./assets/js/components/_social_icons.js